<template>
  <section v-on:click="sectionClicked">
    <div class="sliderOuter" v-on:mouseover="sliderMouseEnter"
      v-on:mouseleave="sliderMouseLeave" v-on:mouseup="sliderMouseLeave"
      :class="{fs: section.fullScreen}">
      <div class="sliderCnt">
        <div class="sliderWrapper">
          <div class="sliderPlayPause" :class="{paused: sliderpuase}"
            v-on:click.stop="forceSliderPause"></div>
          <div class="sliderSc" :style="{width: `${section.items.length}00%`}"
            :class="`s${slideActive}`" v-if="section.items.length > 0">
            <div class="sliderIn" v-for="(slider, i) in section.items" :key="`slide${i}`"
              :style="{width: `${100/section.items.length}%`}"
              :class="[slider.type, `text-align-${slider.textAlign}`,
              {'text-shadow': slider.textShadow}]">
              <div class="slider-content" v-if="slider.title[lang] || slider.descriptions[lang]"
                :style="{'font-family': slider.font !== 'default' ? slider.font : '',
                color: slider.textColor ? slider.textColor
                : (slider.type === 'imgBg' ? '#ffffff' : '#444444')}">
                <div class="title" v-if="slider.title[lang]">
                  {{slider.title[lang]}}
                </div>
                <div class="desc" v-if="slider.descriptions[lang]">
                  {{slider.descriptions[lang]}}
                </div>
                <button  class="btn playBtn" v-on:click.stop="openVideo(slider)"
                  v-if="slider.media[lang] && slider.media[lang].type === 'video'">
                  <span v-if="slider.buttonLabel[lang]">{{slider.buttonLabel[lang]}}</span>
                  <span v-else-if="lang === 'id'">Tonton Video</span>
                  <span v-else>Watch Video</span>
                </button>
                <a :href="slider.url" class="btn" v-else-if="slider.url"
                  target="_blank">
                  <span v-if="slider.buttonLabel[lang]">
                    {{slider.buttonLabel[lang]}}
                  </span>
                  <span v-else-if="lang === 'id'">Pelajari Lebih Lanjut</span>
                  <span v-else>Learn More</span>
                </a>
              </div>
              <div class="playIcon" v-on:click.stop="openVideo(slider)"
                v-else-if="slider.media[lang] && slider.media[lang].type === 'video'">
                <div class="icon"></div>
                <span v-if="slider.buttonLabel[lang]">{{slider.buttonLabel[lang]}}</span>
                <span v-else-if="lang === 'id'">Tonton Video</span>
                <span v-else>Watch Video</span>
              </div>
              <div class="slider-overlay" v-if="slider.imageOverlay && slider.type === 'imgBg'"
                :style="{'background-color': slider.overlayColor, opacity:
                slider.overlayOpacity}"></div>
              <div class="slider-bg"
                v-if="slider.cover[lang] && slider.media[lang].type === 'video'"
                :style="{'background-image': `url(${slider.cover[lang].imageLg})`}"></div>
              <div class="slider-bg"
                v-else-if="slider.media[lang] && slider.media[lang].mimetype === 'video/youtube'"
                :style="{'background-image': `url(${slider.media[lang].thumbHd})`}"></div>
              <div class="slider-bg"
                v-else-if="slider.media[lang] && slider.media[lang].type === 'video'"
                :style="{'background-image': `url(${slider.media[lang].mainThumb})`}"></div>
              <div class="slider-bg"
                v-else-if="slider.media[lang]"
                :style="{'background-image': `url(${slider.media[lang].imageLg})`}"></div>
            </div>
          </div>
          <div class="sliderSc s0" :style="{width: '100%'}" v-else>
            <div class="sliderIn" :style="{width: '100%'}">
              <div class="slider-bg noImg"></div>
            </div>
          </div>
        </div>
        <div class="sliderNav" v-if="section.items.length > 1">
          <div class="navItem navPrev" v-if="slideActive > 0"
            v-on:click="slideActive -= 1"></div>
          <div class="navItem navNext" v-if="slideActive < section.items.length - 1"
            v-on:click="slideActive += 1"></div>
        </div>
        <div class="sliderPager" v-if="section.items.length > 1"
          v-on:mouseover="sliderpuase = true"
          v-on:mouseup="sliderpuase = false" v-on:mouseleave="sliderpuase = false">
          <div class="pagerItem" v-for="(s, i) in section.items" :key="`sp${i}`"
            :class="{active: slideActive === i}" v-on:click="slideActive = i"></div>
        </div>
      </div>
    </div>
    <VideoDialog ref="videoPlayer"/>
  </section>
</template>

<script>
import VideoDialog from '@/components/VideoDialog.vue';

export default {
  name: 'home',
  props: ['section'],
  components: { VideoDialog },
  data() {
    return {
      maru1Offset: 40,
      scrolled: false,
      newsIdx: 0,
      ch: null,
      loading: true,

      /**
       * Slider
       *
       */
      sliders: [],
      slideActive: 0,
      sliderpuase: false,
      sliderpuaseForced: false,

      /**
       * Number
       *
       */
      numbers: [],

      /**
       * News
       *
       */
      news: [],

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
      // const scScale = (window.innerWidth > 960) ? 0.2 : 0.1;
      // this.maru1Offset = -(window.scrollY - (this.$refs.maruHelper.offsetTop - 400)) * scScale;
      // if (this.maru1Offset > 40) this.maru1Offset = 40;
    },
    sliderMouseEnter() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = true;
    },
    sliderMouseLeave() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = false;
    },
    forceSliderPause() {
      setTimeout(() => {
        this.sliderpuase = !this.sliderpuase;
        this.sliderpuaseForced = this.sliderpuase;
      });
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    prevNews() {
      if (this.newsIdx < 1) return;
      this.newsIdx -= 1;
    },
    nextNews() {
      if (this.newsIdx > 2) return;
      this.newsIdx += 1;
    },
    nextNews2() {
      if (this.newsIdx > 3) return;
      this.newsIdx += 1;
    },
    openVideo(item) {
      this.$refs.videoPlayer.open(item.media[this.lang]);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style lang="scss">
.previewContent{
  &.tablet{
    .sliderOuter{
      &.fs{
        .sliderWrapper{
          .sliderSc{
            .sliderIn{
              height: 360px;
            }
          }
        }
      }
    }
  }
  &.mobile{
    .sliderOuter{
      &.fs{
        .sliderWrapper{
          .sliderSc{
            .sliderIn{
              height: 200px;
            }
          }
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.sliderOuter{
  position: relative;
  margin: 0 auto 24px;
  max-width: 1320px;
  @media (max-width: 1480px) {
    max-width: 1200px;
  }
  @media (max-width: 1260px) {
    max-width: none;
    margin: 0 30px;
  }
  @media (max-width: 960px) {
    margin: 0 20px;
  }
  .sliderCnt{
    position: relative;
  }
  .sliderWrapper{
    overflow: hidden;
    position: relative;
    .sliderPlayPause{
      width: 30px; height: 30px;
      border-radius: 50%;
      position: absolute;
      right: 10px; top: 10px;
      background-image: url(../../assets/play-icon-white.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 4;
      cursor: pointer;
      display: none;
      @media (max-width: 680px) {
        display: block;
        background-size: 14px auto;
      }
      &.paused{
        background-image: url(../../assets/pause-white.png);
      }
    }
    .sliderSc{
      display: flex;
      transition: all .7s ease;
      .sliderIn{
        position: relative;
        background-color: #fff;
        display: block;
        height: 640px;
        border-radius: 10px;
        transition: all .3s ease;
        @media (max-width: 1480px) {
          height: 560px;
        }
        @media (max-width: 1260px) {
          height: 48vw;
        }
        @media (max-width: 768px) {
          height: 56vw;
          border-radius: 6px;
        }
        .playIcon{
          position: absolute;
          left: 50%; top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          text-align: center;
          font-size: 14px;
          opacity: .56;
          transition: all .3s ease;
          cursor: pointer;
          padding: 14px 20px;
          border-radius: 7px;
          &:hover{
            background-color: rgba(0, 0, 0, .2);
          }
          .icon{
            width: 50px; height: 50px;
            background-size: 24px auto;
            background-position: 15px 50%;
            background-repeat: no-repeat;
            background-image: url(../../assets/play-icon-white.png);
            border-radius: 50%;
            border: #fff 2px solid;
            margin: 0 auto 10px;
          }
        }
        &:hover{
          .playIcon{
            opacity: 1;
          }
        }
        .slider-bg{
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          background-color: #fff;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 10px;
          &.noImg{
            background-image: url(../../assets/image-black.png);
            background-size: 64px auto;
            background-color: #ccc;
            opacity: .3;
          }
        }
        .slider-overlay{
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          z-index: 3;
          border-radius: 10px;
          @media (max-width: 768px) {
            border-radius: 6px;
          }
        }
        .slider-content{
          color: #fff;
          position: absolute;
          z-index: 7;
          top: 50%;
          transform: translate(0, -50%);
          right: 10%;
          left: 10%;
          bottom: 1.25rem;
          padding-top: 1.25rem;
          padding-bottom: 1.25rem;
          text-align: left;
          height: max-content;
          box-sizing: border-box;
          @media (max-width: 680px) {
            left: 20px; right: 20px;
          }
          .title{
            font-size: 3rem;
            font-weight: bold;
            line-height: 1.1;
            margin: 0 0 14px;
            @media (max-width: 960px) {
              font-size: 40px;
            }
            @media (max-width: 768px) {
              // text-align: center;
            }
            @media (max-width: 680px) {
              font-size: 26px;
              margin: 0 0 6px;
            }
            @media (max-width: 480px) {
              font-size: 20px;
            }
          }
          .desc{
            font-size: 17px;
            max-width: 760px;
            line-height: 1.4;
            @media (max-width: 768px) {
              text-align: center;
              max-width: none;
            }
            @media (max-width: 680px) {
              font-size: 13px;
              line-height: 1.1;
            }
          }
          .btn{
            color: #fff;
            background-color: #008552;
            border: 1px solid #008552;
            font-weight: normal;
            // text-shadow: inherit;
            transition: all 600ms;
            margin: 0;
            margin-top: 14px;
            display: inline-block;
            width: max-content;
            height: max-content;
            padding: .6rem 1rem;
            font-size: 1rem;
            border-radius: .25rem;
            &.playBtn{
              padding-left: 38px;
              position: relative;
              &:before, &:after{
                content: "";
                position: absolute;
                left: 12px; top: 0; bottom: 0; width: 16px;
                background-image: url(../../assets/play-icon-white.png);
                background-size: 16px auto;
                background-position: center;
                background-repeat: no-repeat;
                transition: all .3s ease;
              }
              &:after{
                background-image: url(../../assets/play-icon.png);
                opacity: 0;
              }
            }
            &:hover {
              color: #fff;
              background-color: #006a42;
              border-color: #006a42;
              // text-shadow: none;
              &:before{
                opacity: 0;
              }
              &:after{
                opacity: 1;
              }
            }
            @media (max-width: 768px) {
              margin-left: auto;
            }
          }
        }
        &.text-shadow{
          .slider-content{
            text-shadow: 1px 1px 6px rgba(0,0,0,.3);
          }
        }
        &.text-align-right{
          .slider-content{
            text-align: right;
            .desc{
              margin-left: auto;
            }
          }
        }
        &.text-align-center{
          .slider-content{
            text-align: center;
            .desc{
              margin-left: auto;
              margin-right: auto;
            }
          }
        }
        &.imgLeft{
          .slider-overlay{
            display: none;
          }
          .slider-bg{
            background-size: contain;
            left: 60px; top: 50%; right: auto;
            width: calc(46% - 120px); height: 86%;
            transform: translateY(-50%);
            border-radius: 5px;
          }
          .slider-content{
            left: 46%; right: 0;
            padding: 10px 0;
            padding-right: 40px;
            .title, .desc{
              max-width: none;
              text-shadow: none;
              width: auto;
            }
            .title{
              margin: 0 0 10px;
              font-size: 38px;
              line-height: 1;
            }
            .desc{
              padding: 0;
              font-size: 16px;
              line-height: 1.3;
            }
          }
        }
        &.imgRight{
          .slider-overlay{
            display: none;
          }
          .slider-bg{
            background-size: contain;
            right: 60px; top: 50%; left: auto;
            width: calc(46% - 120px); height: 86%;
            transform: translateY(-50%);
            border-radius: 5px;
          }
          .slider-content{
            right: 46%; left: 0;
            padding: 10px 0;
            padding-right: 40px;
            .title, .desc{
              max-width: none;
              text-shadow: none;
              width: auto;
            }
            .title{
              margin: 0 0 10px;
              font-size: 38px;
              line-height: 1;
            }
            .desc{
              padding: 0;
              font-size: 16px;
              line-height: 1.3;
            }
          }
        }
      }
      &.s1{
        margin-left: -100%;
      }
      &.s2{
        margin-left: -200%;
      }
      &.s3{
        margin-left: -300%;
      }
      &.s4{
        margin-left: -400%;
      }
      &.s5{
        margin-left: -500%;
      }
      &.s6{
        margin-left: -600%;
      }
      &.s7{
        margin-left: -700%;
      }
      &.s8{
        margin-left: -800%;
      }
      &.s9{
        margin-left: -900%;
      }
      &.s10{
        margin-left: -1000%;
      }
      &.s11{
        margin-left: -1100%;
      }
      &.s12{
        margin-left: -1200%;
      }
      &.s13{
        margin-left: -1300%;
      }
      &.s14{
        margin-left: -1400%;
      }
      &.s15{
        margin-left: -1500%;
      }
      &.s16{
        margin-left: -1600%;
      }
      &.s17{
        margin-left: -1700%;
      }
      &.s18{
        margin-left: -1800%;
      }
    }
  }
  .sliderNav{
    .navItem{
      position: absolute;
      z-index: 7;
      background-color: red;
      top: 50%;
      margin-top: -23px;
      width: 46px; height: 46px;
      background-color: #fff;
      border-radius: 50%;
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
      transition: all .3s ease;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      cursor: pointer;
      &:hover{
        box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
      }
      &.navPrev{
        background-image: url(../../assets/arrow-left-black.png);
        left: -23px;
      }
      &.navNext{
        background-image: url(../../assets/arrow-right-black.png);
        right: -23px;
      }
    }
  }
  .sliderPager{
    display: flex;
    justify-content: center;
    margin-top: 4px;
    position: absolute;
    bottom: -16px; left: 20px; right: 20px;
    .pagerItem{
      width: 8px; height: 8px;
      background-color: #ccc;
      border-radius: 50%;
      margin: 0 5px;
      cursor: pointer;
      &.active{
        background-color: #008552;
      }
    }
  }
  &.fs{
    max-width: none;
    margin-bottom: 0;
    .sliderCnt{
      overflow: hidden;
    }
    .sectionHeader{
      padding-top: 60px;
    }
    .sliderPager{
      bottom: 14px;
    }
    .sliderNav{
      .navItem{
        &.navPrev{
          left: 30px;
        }
        &.navNext{
          right: 30px;
        }
      }
    }
    .sliderWrapper{
      .sliderSc{
        .sliderIn{
          height: calc(100vh - 74px);
          border-radius: 0;
          .slider-bg, .slider-overlay{
            border-radius: 0;
          }
          .slider-content{
            position: absolute;
            top: 50%; right: 15%; left: 15%;
            transform: translate(0, -50%);
            padding-top: 1.25rem;
            padding-bottom: 1.25rem;
            @media (max-width: 768px) {
              left: 44px; right: 44px;
            }
            .title {
              font-size: 4.0625rem;
              @media (max-width: 1240px) {
                font-size: 3.6rem;
              }
              @media (max-width: 768px) {
                font-size: 2.2rem;
                line-height: 1.16;
              }
            }
            .desc {
              font-size: 1.2rem;
              width: calc(max(60%,30rem));
              padding-top: 1rem;
              @media (max-width: 768px) {
                font-size: 15px;
                line-height: 1.2;
                width: 100%;
              }
            }
          }
          &.imgLeft{
            .slider-bg{
              background-size: contain;
              left: 80px; top: 50%; right: auto;
              width: calc(50% - 180px); height: 80%;
              transform: translateY(-50%);
              border-radius: 5px;
            }
            .slider-content{
              left: 50%; right: 0;
              padding: 10px 40px;
              padding-left: 0;
              .title, .desc{
                max-width: none;
                text-shadow: none;
                width: auto;
              }
              .title{
                margin: 0 0 10px;
                font-size: 48px;
                line-height: 1;
              }
              .desc{
                padding: 0;
                font-size: 18px;
                line-height: 1.3;
              }
            }
          }
          &.imgRight{
            .slider-bg{
              background-size: contain;
              right: 80px; top: 50%; left: auto;
              width: calc(50% - 180px); height: 80%;
              transform: translateY(-50%);
              border-radius: 5px;
            }
            .slider-content{
              right: 50%; left: 0;
              padding: 10px 40px;
              padding-right: 0;
              .title, .desc{
                max-width: none;
                text-shadow: none;
                width: auto;
              }
              .title{
                margin: 0 0 10px;
                font-size: 48px;
                line-height: 1;
              }
              .desc{
                padding: 0;
                font-size: 18px;
                line-height: 1.3;
              }
            }
          }
        }
      }
    }
  }
}
</style>
